import { render, staticRenderFns } from "./TrueFalseAnswer.vue?vue&type=template&id=058a8ac2&scoped=true&"
import script from "./TrueFalseAnswer.vue?vue&type=script&lang=js&"
export * from "./TrueFalseAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a8ac2",
  null
  
)

export default component.exports